/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Cloudflare_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Watch URL or video ID" |
*
* @param {New_Project_Cloudflare_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_cloudflare_url_placeholder = /** @type {((inputs?: New_Project_Cloudflare_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Cloudflare_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL de visionnage ou ID vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Watch-URL oder Video-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL di visualizzazione o ID video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL просмотра или ID видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de visualización o ID de video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("观看 URL 或视频 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("視聴URLまたは動画ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉच URL या वीडियो ID")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL de visualização ou ID do vídeo")
	return /** @type {LocalizedString} */ ("Watch URL or video ID")
});